import { h } from 'preact'

import sharedStyles from '../sharedStyles.module.scss'

export default function FormInput({
  error,
  handleInputChange,
  identifier,
  input,
  value,
  id,
  displayBlock = false,
}) {
  return (
    <div
      className={`${sharedStyles.FormInputGroup} ${
        displayBlock ? sharedStyles.FormInputGroupBlock : ''
      }`}
    >
      <label
        className={`${sharedStyles.FormInputLabel} ${
          displayBlock ? sharedStyles.FormInputLabelBlock : ''
        }`}
        htmlFor={id}
      >
        {input.label}
      </label>
      <div
        className={`${sharedStyles.FormInputContainer} ${
          input?.class && sharedStyles[`FormInputContainer${input?.class}`]
            ? sharedStyles[`FormInputContainer${input?.class}`]
            : ''
        }`}
      >
        <div className={sharedStyles.FormInputWrapper}>
          {input.type === 'select' ? (
            <div className={sharedStyles.FormInputSelectContainer}>
              <select
                onChange={e => handleInputChange(identifier, e.target.value)}
                value={value}
                className={`${sharedStyles.FormInput} ${
                  sharedStyles.FormInputSelect
                } ${
                  input?.class && sharedStyles[input?.class]
                    ? sharedStyles[input?.class]
                    : ''
                }`}
                id={id}
              >
                {input.options.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <input
              id={id}
              type={input.type}
              value={value}
              onInput={e => handleInputChange(identifier, e.target.value)}
              className={`${sharedStyles.FormInput}`}
            />
          )}
        </div>
        {error && <p className={sharedStyles.FormInputError}>{error}</p>}
      </div>
    </div>
  )
}
